import { ReactElement, ReactNode } from 'react';

import { Tooltip } from '@material-ui/core';

import { ButtonIcon } from '@backstage/ui';

import { useStyles } from './styles';
import { MenuId } from './useMenuState';

type ToolbarDropdownProps = {
  id: MenuId;
  label: string;
  icon: ReactElement;
  openMenu: MenuId | null;
  onToggle: (id: MenuId) => void;
  children: ReactNode;
};

export const ToolbarDropdown = ({
  id,
  label,
  icon,
  openMenu,
  onToggle,
  children,
}: ToolbarDropdownProps) => {
  const classes = useStyles();

  return (
    <div className={classes.menuContainer}>
      <Tooltip title={label}>
        <ButtonIcon
          size="medium"
          aria-label={label}
          onClick={() => onToggle(id)}
          icon={icon}
          variant={openMenu === id ? 'primary' : 'tertiary'}
        />
      </Tooltip>
      {openMenu === id && <div className={classes.popover}>{children}</div>}
    </div>
  );
};
